import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import redirects from "../redirects";

const RedirectMiddleware = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Define any query params that indicate a tracking / referral link
    const trackingParams = ["trk", "ref", "pos", "cmd"];
    const hasTracking = trackingParams.some((p) => params.has(p));

    if (hasTracking) {
      console.log(`Redirecting from ${location.search} → clean homepage`);
      navigate("/", { replace: true });
    } else {
      const currentPath = location.pathname;
      const redirectPath = redirects[currentPath];

      if (redirectPath && redirectPath !== currentPath) {
        console.log(`Redirecting from ${currentPath} to ${redirectPath}`);
        navigate(redirectPath, { replace: true });
      }
    }
  }, [location, navigate]);

  return children;
};

export default RedirectMiddleware;
